import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthCard } from "@/pages/ResetPassword";
import { Onboarding } from "@/components/Onboarding";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [invite, setInvite] = useState(null);
  const [inviteError, setInviteError] = useState("");

  useEffect(() => {
    if (!token) { setInvite(false); setInviteError("This invitation link is missing its token."); return; }
    api.get(`/auth/invite/${token}`)
      .then(({ data }) => setInvite({ ...data, token }))
      .catch((err) => { setInvite(false); setInviteError(formatApiError(err.response?.data?.detail)); });
  }, [token]);

  if (invite === null) return <AuthCard title="Loading invitation…" />;
  if (invite === false) return <AuthCard title="Invitation unavailable" subtitle={inviteError} />;
  return <Onboarding invite={invite} orgName={invite.brand?.name || "Mission Control"} showVideo />;
}
